module.exports = __webpack_public_path__ + "img/missionaries28_2019_7-7-2021.7702766a.jpg";